
import React from "react";
import { useAuth } from "@/context/auth";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";

interface LogoutButtonProps {
  variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link" | "hero-outline";
  className?: string;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ 
  variant = "destructive", 
  className = "" 
}) => {
  const { logout } = useAuth();
  
  const handleLogout = async () => {
    if (logout) {
      await logout();
    } else {
      console.error("Logout function not found in auth context");
      // Fallback to direct page navigation
      window.location.href = '/?logout=' + new Date().getTime();
    }
  };
  
  return (
    <Button 
      variant={variant} 
      onClick={handleLogout} 
      className={`flex items-center ${className}`}>
      <LogOut className="h-4 w-4 mr-2" />
      Logga ut
    </Button>
  );
};

export default LogoutButton;
